import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

interface LoadAutoDesignResultArgs {
  project_id: number | null
  identifier: string | null
}

export const TOOL_NAME = 'load_auto_design_result'

export function LoadAutoDesignResultToolCall(functionCall: LiveFunctionCall, history: any) {
  const args = functionCall.args as LoadAutoDesignResultArgs

  return window.AutoDesignHelper.loadAutoDesignResult(args.project_id, args.identifier)
}
